import { render } from "./Tax.vue?vue&type=template&id=7b0795c5&scoped=true"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"

import "./Tax.vue?vue&type=style&index=0&id=7b0795c5&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0795c5"]])

export default __exports__